export default __webpack_public_path__ + "img/component-profile-card.52a3ee76.png";